import {
  CheckCircle,
  Eye,
  Info,
  PlusCircle,
  Sliders,
  Vote,
} from "@tamagui/lucide-icons";
import type { LearnAboutInfo } from "../LearnScreen";

export const PollLearnMore: LearnAboutInfo[] = [
  {
    titleIcon: Vote,
    title: "Poll",
    subtitle: "Ask a question and vote for the best option together",
    image: require("../../../../web_legacy/static/poll_card_preview.webp"),
    featureList: [
      {
        icon: PlusCircle,
        text: "1. Enter your options",
      },
      {
        icon: Vote,
        text: "2. Vote & see what everyone else has voted",
      },
      {
        icon: CheckCircle,
        text: "3. Select the best option together",
      },
      {
        icon: Eye,
        text: "4. See the final option on the overview",
      },
    ],
    descriptions: [
      {
        icon: Info,
        title: "What is it?",
        description:
          "Make group decisions a breeze with quick polls, allowing members to vote on options or preferences effortlessly",
      },

      {
        icon: Sliders,
        title: "Extra options",
        description:
          "You can also limit so you are only allowed to cast a vote for a single option, or add a description to make sure the group knows what you vote for.",
      },
    ],
  },
];
